import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { IProductListPagination } from '~/features/pagination/models/pagination';
import { IFilter } from '~/lib/data-contract';

const TAKE_PARAMETER_REGEX = /take=\d*/;

/**
 * "Load more" pagination style, no client-side fetching just link and route change
 * Only provides how many items more would be loaded in the next page and a link to it
 * Unoptimized as it loads duplicate data again
 */
// export const useProductListPagination = (page: { items: ProductListItem[]; take: number; total: number; pageSize: number }): IProductListPagination => {
export const useProductListPagination = (page: IFilter['page']): IProductListPagination => {
	const routerAsPath = useRouter().asPath;

	return useMemo(() => {
		const { items, take, pageSize, total } = page;

		const productsCount = items.filter(({ type }) => type === 'variationDetails').length;
		const promotionsCount = take - productsCount;
		const nextPageTake = take + pageSize;
		const nextPageItemCount = Math.min(total + promotionsCount - take, pageSize);

		let nextPageLink = routerAsPath;
		if (nextPageLink.includes('take=')) {
			nextPageLink = nextPageLink.replace(TAKE_PARAMETER_REGEX, `take=${nextPageTake}`);
		} else if (nextPageLink.includes('?')) {
			nextPageLink += `&take=${nextPageTake}`;
		} else {
			nextPageLink += `?take=${nextPageTake}`;
		}

		return { ...page, nextPageItemCount, nextPageLink, productsCount, promotionsCount };
	}, [page, routerAsPath]);
};
